var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleMemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 64,
    viewBox: "0 0 52 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1755 5.54199H16.6227V11.0838H11.0809V18.0111H5.53906V51.2621H11.0809V58.1893H40.1755V51.2621H45.7173V18.0111H40.1755V5.54199Z",
    fill: "#FFB800"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.8594,
    y: 31.8652,
    width: 5.54183,
    height: 20.0891,
    fill: "#FFD582"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.625,
    width: 23.5528,
    height: 5.54183,
    fill: "#190D11"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.082,
    y: 5.54199,
    width: 5.54183,
    height: 5.54183,
    fill: "#190D11"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.53906,
    y: 45.7207,
    width: 5.54183,
    height: 5.54183,
    fill: "#B96F3A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.082,
    y: 45.7207,
    width: 5.54183,
    height: 6.92728,
    fill: "#BF6717"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.082,
    y: 52.6475,
    width: 11.7764,
    height: 5.54183,
    fill: "#BF6717"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0938,
    y: 24.9385,
    width: 5.54183,
    height: 5.54183,
    fill: "#FFD582"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1797,
    y: 45.7207,
    width: 5.54183,
    height: 5.54183,
    fill: "#DB954C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1797,
    y: 40.1787,
    width: 5.54183,
    height: 5.54183,
    fill: "#FFD582"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8594,
    y: 37.4072,
    width: 5.54183,
    height: 7.62001,
    fill: "#190D11"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3203,
    y: 24.9385,
    width: 5.54183,
    height: 20.0891,
    fill: "#FFD582"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5547,
    y: 11.084,
    width: 5.54183,
    height: 7.62001,
    fill: "#FFD582"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 34.6367,
    y: 40.1787,
    width: 5.54183,
    height: 11.0837,
    fill: "#FFD582"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 34.6367,
    y: 5.54199,
    width: 5.54183,
    height: 5.54183,
    fill: "#FDFBFB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 34.6367,
    y: 24.9385,
    width: 11.0837,
    height: 5.54183,
    fill: "#FDFBFB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 34.6367,
    y: 34.6367,
    width: 11.0837,
    height: 5.54183,
    fill: "#FFD582"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 11.082,
    y: 58.1895,
    width: 29.0946,
    height: 5.54183,
    fill: "#190D11"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    y: 18.0107,
    width: 5.54183,
    height: 33.251,
    fill: "#190D11"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 5.53906,
    y: 18.0107,
    width: 5.54183,
    height: 27.7091,
    fill: "#BF6717"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 5.53906,
    y: 11.084,
    width: 5.54183,
    height: 6.92728,
    fill: "#190D11"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 11.082,
    y: 11.084,
    width: 5.54183,
    height: 6.92728,
    fill: "#BF6717"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 34.6367,
    y: 11.084,
    width: 5.54183,
    height: 13.8546,
    fill: "#FFD582"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 5.53906,
    y: 51.2617,
    width: 5.54183,
    height: 6.92728,
    fill: "#190D11"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1797,
    y: 51.2617,
    width: 5.54183,
    height: 6.92728,
    fill: "#190D11"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1797,
    y: 5.54199,
    width: 5.54183,
    height: 12.4691,
    fill: "#190D11"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7188,
    y: 18.0107,
    width: 5.54183,
    height: 33.251,
    fill: "#190D11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleMemberIcon);
export default __webpack_public_path__ + "static/media/role_member_icon.e2c6b3560f5448fd3e1f536d0244575e.svg";
export { ForwardRef as ReactComponent };